import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {DateString} from "./Projects";

export class ProjectJournal extends SubAPI {

    list(props: {
        project?: number
        offset?: number;
        deliveries?: string // csv
    }) {
        return this.fetcher.get<Paginated<JournalEntry>>("/api/project-journal", props)
    }
}

export type JournalEntry = {
    id: number;
    project: number;
    createdAt: DateString;
    createdBy?: number;
    createdByName?: string;
} & ({
    type: "outbound-email",
    args: {
        subject: string;
        attachments: {File: number; Name: number}[];
    },
    emailQueue: number
} | {
    type: "delivery-complete",
    args: {
        name: string;
        route?: number; // direct to site don't have a route

        signedFiles?: {File: number; Name: string}[];
        signedByName?: string;
        signedAt?: DateString;

        proofFiles?: {File: number; Name: string}[];
    },
    delivery: number;
    emailQueue: number | null;
})